type Props = {
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export default function CalisthenicsIcon({ size = 32, strokeWidth = 1.5, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="7" y1="6" x2="7" y2="19" />
      <line x1="17" y1="6" x2="17" y2="19" />
    </svg>
  );
}
